export function HideBatteryVoltageSample(assetModel, measurementModel) {
    return SensorProviderCheck(assetModel) && measurementModel.name == "BatteryVoltage";
}
export function SensorProviderCheck(assetModel) {
    return (assetModel.feedSource.dataType == "PvhLinkSensorGen2EventsV1" || assetModel.feedSource.dataType == "PvhSigfoxEventsV1");
}
